const AppConfigs = {
    emailSupport: 'support@dnk.com.vn',
    copyright: '@DnK',
    supportUploadImageFileTypes: '.png, .jpg, .jpeg, .wepb',
    supportUploadVideoFileTypes: '.mp4, .mov',
    baseUrl: 'https://dnk.mdcsoftware.com.vn',
    wsUrl: 'wss://dnk.mdcsoftware.com.vn/ws'
};

export default AppConfigs;